import { selectFeatureFlags } from 'core/userContext';
import { useProjectUsage } from 'modules/billing/hooks/useProjectUsage';
import { useSelector } from 'react-redux';
import { USERS_METRICS } from '../../constants';
import { queryByFn } from '../../utils';
import { SimpleIndexPage } from '../SimpleIndexPage/SimpleIndexPage';
import { ProjectUsagePageActions } from './ProjectUsagePageActions';
import { createRowCell } from './TableCell';

export const USERS_PROJECT_USAGE_TEXT = {
  pageTitle: 'Users usage',
};

export const UsersProjectUsage = () => {
  const { AllowActiveUsersMetricInBilling } = useSelector(selectFeatureFlags);

  const metricNames = [
    USERS_METRICS.totalUsersAllTime,
    USERS_METRICS.totalUsersAddedInPeriod,
    ...(AllowActiveUsersMetricInBilling
      ? [USERS_METRICS.activeUsersAllTime, USERS_METRICS.activeUsersAddedInPeriod]
      : []),
  ];

  const { breadcrumb, columns, isLoading, rows } = useProjectUsage(metricNames);

  return (
    <SimpleIndexPage
      breadcrumb={breadcrumb}
      columns={columns}
      createRowCell={createRowCell}
      isLoading={isLoading}
      pageActions={<ProjectUsagePageActions />}
      pageTitle={USERS_PROJECT_USAGE_TEXT.pageTitle}
      queryByFn={queryByFn}
      rows={rows}
    />
  );
};
